import UntypedDatalist from './DataList';

const DataList = UntypedDatalist as any;

export default DataList;

export { DataListIconPositions } from './DataList';
